import React, { useState, useEffect } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import axios from "axios";
import backgroundImage from "../../assets/img/fondoSiete.png";
import HeaderAdmin from "../header/HeaderAdmin";
import useNivelesPreguntas from "../../hooks/useNivelesPreguntas";
import Swal from "sweetalert2";

const EvaluacionFinal = () => {
  const { temaId } = useParams();
  const navigate = useNavigate();
  const [tema, setTema] = useState(null);
  const [preguntas, setPreguntas] = useState([]);
  const [nuevoTema, setNuevoTema] = useState("");

  // Funcionalidades del hook
  const {
    showMultimedia,
    multimediaUrl,
    multimediaType,
    handleFileChange,
    handleUpload,
    setShowMultimedia,
    error,
    setError,
  } = useNivelesPreguntas();
  const API_BASE_URL = process.env.REACT_APP_API_URL || "";
  const token = localStorage.getItem("token");

  useEffect(() => {
    const cargarDatos = async () => {
      try {
        const headers = {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        };

        const [respPreguntas] = await Promise.all([
          axios.get(`${API_BASE_URL}/api/preguntas/tema/${temaId}`, headers),
        ]);

        setPreguntas(respPreguntas.data);
      } catch (err) {
        console.error("Error cargando datos:", err);
        setError("Error al cargar los datos del tema");
      }
    };

    if (temaId) cargarDatos();
  }, [temaId]);

  // Eliminar pregunta con confirmación
  const handleEliminarPregunta = async (id) => {
    const result = await Swal.fire({
      title: "¿Eliminar pregunta?",
      text: "¡No podrás revertir esto!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Sí, eliminar",
    });
    const headers = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    if (result.isConfirmed) {
      try {
        await axios.delete(`${API_BASE_URL}/api/preguntas/${id}`, headers);
        setPreguntas(preguntas.filter((p) => p.id !== id));
        Swal.fire("¡Eliminada!", "La pregunta fue eliminada.", "success");
      } catch (err) {
        setError("Error al eliminar la pregunta");
      }
    }
  };

  // Modal multimedia mejorado
  const renderMultimediaModal = () => {
    if (!showMultimedia) return null;

    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4">
        <div className="bg-white rounded-lg shadow-xl w-full max-w-4xl max-h-[90vh] flex flex-col">
          <div className="flex justify-between items-center p-4 border-b">
            <h3 className="text-xl font-bold">Contenido de la Evaluacion</h3>
            <button
              onClick={() => setShowMultimedia(false)}
              className="text-gray-500 hover:text-gray-700"
            >
              ✕
            </button>
          </div>
          <div className="flex-grow overflow-auto p-4">
            {multimediaUrl ? (
              multimediaType === "image" ? (
                <img
                  src={multimediaUrl}
                  alt="Contenido multimedia"
                  className="max-w-full max-h-[60vh] mx-auto object-contain"
                />
              ) : (
                <video
                  src={multimediaUrl}
                  controls
                  className="max-w-full max-h-[60vh] mx-auto"
                />
              )
            ) : (
              <p className="text-center text-gray-600">
                No hay contenido multimedia.
              </p>
            )}
          </div>
          <div className="p-4 border-t">
            <input
              type="file"
              onChange={handleFileChange}
              accept="video/*,image/*"
              className="mb-2 w-full"
            />
            <button
              onClick={handleUpload}
              className="w-full bg-green-700 hover:bg-green-800 text-white py-2 rounded"
            >
              Cargar nuevo material
            </button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div
      className="min-h-screen flex flex-col"
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: "cover",
      }}
    >
      <HeaderAdmin />

      <div className="bg-white w-full py-2 text-center text-lg font-montserrat font-extrabold">
        Identidad Institucional
      </div>

      <div className="flex-grow flex flex-col sm:flex-row p-4 gap-4">

        {/* Panel lateral (opcional) */}
        <div className="w-full sm:w-1/4 bg-white rounded-lg p-4 shadow-lg">
          <h2 className="text-xl font-bold mb-4">Opciones</h2>
          <button
            onClick={() => navigate(-1)}
            className="w-full text-left px-4 py-2 bg-gray-100 hover:bg-green-600 hover:text-white rounded transition-colors"
          >
            ← Volver atrás
          </button>
        </div>

        {/* Contenido principal */}
        <div className="w-full sm:w-3/4 bg-white rounded-lg p-6 shadow-lg flex flex-col">
        
          {/* Cabecera */}
          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 gap-4">
            <div>
              <h2 className="text-2xl font-bold">
                {tema?.nombre || "DEBE IR EL NOMBRE DEL TEMA"}
              </h2>
            </div>

            <div className="flex gap-2">

              <button
                onClick={() => setShowMultimedia(true)}
                className="bg-green-700 hover:bg-green-800 text-white px-4 py-2 rounded flex items-center gap-2"
              >
                <span>Contenido</span>
                <svg
                  className="w-5 h-5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 16v1a2 2 0 002 2h12a2 2 0 002-2v-1m-4-8l-4-4m0 0L8 8m4-4v12"
                  />
                </svg>
              </button>

              <Link
                to={`/admin/crear-pregunta?tema=${temaId}`}
                className="bg-green-700 hover:bg-green-800 text-white px-4 py-2 rounded flex items-center gap-2"
              >
                <span>Nueva Pregunta</span>
                <svg
                  className="w-5 h-5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                  />
                </svg>
              </Link>
            </div>
          </div>

          {/* Listado de preguntas */}
          <div className="flex-grow overflow-y-auto">
            <h3 className="text-xl font-bold mb-4">
              Preguntas ({preguntas.length})
            </h3>

            {preguntas.length > 0 ? (
              <div className="space-y-3">
                {preguntas.map((pregunta) => (
                  <div
                    key={pregunta.id}
                    className="bg-gray-50 p-4 rounded-lg border flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3"
                  >
                    <p className="flex-grow font-medium">
                      {pregunta.texto_pregunta}
                    </p>
                    <div className="flex gap-2">
                      <Link
                        to={`/admin/editar-pregunta/${pregunta.id}`}
                        className="bg-yellow-500 hover:bg-yellow-600 text-white px-3 py-1 rounded text-sm"
                      >
                        Editar
                      </Link>
                      <button
                        onClick={() => handleEliminarPregunta(pregunta.id)}
                        className="bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded text-sm"
                      >
                        Eliminar
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="bg-gray-100 p-8 text-center rounded-lg">
                <p className="text-gray-500">No hay preguntas en este tema</p>
                <Link
                  to={`/admin/crear-pregunta?tema=${temaId}`}
                  className="inline-block mt-4 bg-green-700 hover:bg-green-800 text-white px-4 py-2 rounded"
                >
                  Crear primera pregunta
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Mensajes de error */}
      {error && (
        <div className="fixed bottom-0 left-0 right-0 bg-red-500 text-white p-4 text-center animate-fade-in">
          {error}
          <button onClick={() => setError("")} className="ml-4">
            ✕
          </button>
        </div>
      )}

      {renderMultimediaModal()}
    </div>
  );
};

export default EvaluacionFinal;